import { render, staticRenderFns } from "./SupportInformation.vue?vue&type=template&id=302b0766&"
import script from "./SupportInformation.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SupportInformation.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports